import { Component } from '@angular/core';
import { BaseSelectWithIdComponent } from '@app/shared/components/select/base-select-with-id.component';
import { CodeValue } from '@app/shared/models/code-value';
import { SettingsService, SettingsUriBuilderParams } from '@app/core/services/settings.service';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';
import * as _ from 'lodash-es';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';


@Component({
  selector: 'country-select',
  templateUrl: '../base-select-with-id.component.html',
  styleUrls: ['../base-select-with-id.component.scss']
})
export class CountrySelectComponent extends BaseSelectWithIdComponent<CodeValue, SettingsUriBuilderParams> {

  constructor(protected settingsService: SettingsService, protected drI18nService: DrI18nService) {
    super(settingsService);
    this.defaultOptions = {
      label: 'country.name',
      patchPath: '',
      class: 'full-width',
      optional: true,
      uriParams: {
        urlSuffix: 'countries',
        queryParams: {
          locale: DrI18nService.getActiveLocaleInformation().shortName
        }
      },
      propOverride: 'settingsDataList'
    };
  }

  protected formatData(data: CodeValue[]): CodeValue[] {
    _.remove(data, (country: CodeValue) => {
      return !country.code;
    });
    _.each(data, cV => cV.displayName = `${cV.code} - ${cV.value}`);
    data = _.sortBy(data, cV => cV.displayName);
    const removedValues = _.remove(data, cV => cV.code === 'DE');
    const germany = removedValues[0];
    data.unshift(germany);
    return data;
  }

  protected generateUriBuilderParams(): SettingsUriBuilderParams {
    return new SettingsUriBuilderParams();
  }

  public onSelectionChange(): void {
    const patches = new Array<OpData>();
    const selectedCountry = _.find(this.list, (item: CodeValue) => item.id === this.selectedId) as CodeValue;

    patches.push({
      op: OP.replace,
      path: `${this.mergedOptions.patchPath ? `${this.mergedOptions.patchPath}/` : `` }country/code`,
      value: selectedCountry?.code || ''
    });

    patches.push({
      op: OP.replace,
      path: `${this.mergedOptions.patchPath ? `${this.mergedOptions.patchPath}/` : `` }country/value`,
      value: selectedCountry?.value || ''
    });

    this.onMultiUpdate(patches);
  }
}
